(function (angular) {
	'use strict';

	angular
		.module('toastModule')
		.factory('ToastFactory', [
			'$animate',
			'$compile',
			'$document',
			'$rootScope',
			'initialToasts',
			ToastFactoryFunction
		]);

	function ToastFactoryFunction(
		$animate,
		$compile,
		$document,
		$rootScope,
		initialToasts) {

		var factory = {
			init: init,
			show: show
		};

		return factory;

		function init() {
			$rootScope.toasts = initialToasts;
			var body = angular.element($document[0].body);
			var rawTemplate = angular.element('<toast-container toasts="toasts"></toast-container');
			var toastContainerScope = $rootScope.$new();
			var compiledToastContainer = $compile(rawTemplate)(toastContainerScope);
			appendChild(compiledToastContainer, body);
		}

		function appendChild(child, parent) {
			var children = parent.children();
			if (children.length > 0) {
				return $animate.enter(child, parent, children[children.length - 1]);
			}
			return $animate.enter(child, parent);
		}

		function show(toast) {
			$rootScope.toasts.push(toast);
		}
	}
})(window.angular);
